<template>
  <AppSubtitle>Peace兒童相機</AppSubtitle>
  <ul class="text">
    <li>
      <span>羅&emsp;Ｏ</span>
      <span>0911-XXX-609</span>
    </li>
    <li>
      <span>陳Ｏ華</span>
      <span>0937-XXX-196</span>
    </li>
    <li>
      <span>官Ｏ甯</span>
      <span>0958-XXX-091</span>
    </li>
  </ul>
  <AppSubtitle>全家福寫真</AppSubtitle>
  <ul class="text">
    <li>
      <span>曹Ｏ婷</span>
      <span>0978-XXX-506</span>
    </li>
  </ul>
</template>

<script>
import AppSubtitle from '@/components/AppSubtitle';

export default {
  components: { AppSubtitle },
};
</script>

<style lang="scss" scoped>
@import './WinningList.scss';
</style>
